<template>
  <div id="investment" class="investment">
    <div class="zy_constr">
      <div class="investment-main">
        <div class="investment-title">{{ INVESTMENT.title }}</div>
        <div class="investment-desc">{{ INVESTMENT.desc }}</div>
        <div class="investment-list">
          <a class="investment-item" v-for="item in INVESTMENT.list" :key="item.name" :href="item.href" target="_blank"
            >{{ item.name }}<i class="investment-item__icon"></i
          ></a>
        </div>
        <div class="investment-contact">
          <div class="investment-contact__title">联系方式</div>
          <div class="investment-contact__list">
            <div class="investment-contact__item" v-for="item in INVESTMENT.contact" :key="item.name">
              <img class="investment-contact__item__icon" :src="item.icon" alt="" />
              <span>{{ item.name }}：</span><span>{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="investment-contact__bg" v-lazy="bg" alt="" />
  </div>
</template>

<script>
import { INVESTMENT } from '@/config';
import { isMobile } from '@/utils/utils';
export default {
  name: 'Investment',
  data() {
    return {
      INVESTMENT,
      isMobile: isMobile()
    };
  },
  computed: {
    bg() {
      return this.isMobile ? INVESTMENT.bg_wap : INVESTMENT.bg;
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
.zy_constr {
  position: relative;
  height: 100%;
}

.investment {
  position: relative;
  height: 600px;
  background: #ed4244;
}

.investment-main {
  width: 556px;
}

.investment-title {
  padding-top: 80px;
  font-size: 40px;
  color: #fff;
  font-weight: 500;
  line-height: 60px;
}

.investment-desc {
  margin-top: 24px;
  font-size: 16px;
  color: #fff;
  line-height: 28px;
}

.investment-list {
  margin-top: 24px;
  display: flex;
}

.investment-item {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.2);
  font-size: 14px;
  color: #fff;
  margin-left: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  &:first-child {
    margin-left: 0;
  }
  &:hover {
    background: #fff;
    color: #fc5858;
    .investment-item__icon {
      &::after {
        border-color: #fc5858;
      }
    }
  }
}

.investment-item__icon {
  display: block;
  width: 12px;
  height: 12px;
  position: relative;

  &::after {
    transition: all 0.3s ease;
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-75%, -50%) rotate(45deg);
    width: 6px;
    height: 6px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
  }
}

.investment-contact {
  margin-top: 80px;
}

.investment-contact__title {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: #fff;
}

.investment-contact__list {
  margin-top: 24px;
}

.investment-contact__item {
  font-size: 16px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.85);
  &__icon {
    display: none;
  }
}

.investment-contact__bg {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 614px;
  height: 600px;
}

.S {
  .investment {
    height: rem(330 * 3);
    text-align: center;
  }
  .investment-contact__bg {
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .investment-title {
    font-size: rem(60);
    line-height: rem(72);
    padding-top: rem(72);
    text-align: center;
  }
  .investment-desc {
    font-size: rem(42);
    line-height: rem(75);
    text-align: left;
  }
  .investment-list {
    margin-top: rem(72);
    justify-content: space-between;
  }
  .investment-item {
    box-sizing: border-box;
    display: inline-block;
    font-size: rem(36);
    height: rem(96);
    line-height: rem(96);
    border-radius: rem(12);
    margin-left: rem(36);
    padding: 0;
    width: rem(303);
    text-align: center;
    &__icon {
      display: inline-block;
      margin-left: rem(12);
      vertical-align: rem(-3);
    }
    &:first-child {
      margin-left: 0;
    }
  }
  .investment-main {
    box-sizing: border-box;
    width: 100%;
    padding: 0 rem(48);
    position: relative;
    z-index: 1;
  }
  .investment-contact__title {
    display: none;
  }
  .investment-contact {
    margin-top: rem(144);
    text-align: left;
    &__title {
      display: none;
    }
    &__list {
    }
    &__item {
      font-size: rem(42);
      line-height: rem(54);
      margin-bottom: rem(36);
      &:last-child {
        margin-bottom: 0;
      }
      &__icon {
        display: inline-block;
        width: rem(54);
        height: rem(54);
        margin-right: rem(24);
        vertical-align: rem(-10);
      }
      span {
        display: inline-block;
        margin-right: rem(36);
      }
    }
  }
}
/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
    .S .investment-title {
      font-weight: bold;
    }
}
</style>
